import React from 'react';
import PropTypes from 'prop-types';
import { has } from 'lodash';
import gettext from 'js-utils/gettext';

import IconButton from 'eventbrite_design_system/iconButton/IconButton';
import InputField from 'eventbrite_design_system/inputField/InputField';

import './staticEmailField.scss';

import PencilChunkySvg from 'eventbrite_design_system/iconography/icons/PencilChunky';

export default class StaticEmailField extends React.PureComponent {
    static propTypes = {
        email: PropTypes.string.isRequired,
        onEmailEdit: PropTypes.func.isRequired,
        clearNotification: PropTypes.func,
    };

    _handleEmailEdit() {
        const {
            onEmailEdit,
            clearNotification,
            formErrors,
            onEmailMismatch,
        } = this.props;

        clearNotification();
        onEmailEdit();

        if (formErrors && has(formErrors, 'confirmEmail')) {
            onEmailMismatch();
        }
    }

    render() {
        const { email } = this.props;
        const editButton = (
            <IconButton
                iconType={<PencilChunkySvg />}
                onClick={this._handleEmailEdit.bind(this)}
                title={gettext('Edit Email')}
            />
        );

        return (
            <div className="eds-l-mar-top-5 eds-l-mar-bot-4">
                <div className="static-email-field__button">
                    <InputField
                        id="email"
                        label={gettext('Email address')}
                        suffix={editButton}
                        placeholder={email}
                        disabled={true}
                        hasMinAsideSpacing={true}
                        style="static"
                    />
                </div>
            </div>
        );
    }
}
